export default __webpack_public_path__ + "static/media/alertes-2.4c23376a.png";